import { FieldSettings } from '@progress/kendo-react-data-tools'
import { DividendPaymentFilterKey } from 'api/Trading-Accounts/Types/DividendsDto'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { CustomDateFilter } from './common.filter'
import { TradingAccountBrokerSymbolFilter } from './TradingAccountFields/TradingAccountBrokerSymbolFilter'

const getDividendFields = (): FieldSettings[] => [
  {
    name: DividendPaymentFilterKey.brokerSymbol,
    label: 'Broker Symbol',
    filter: TradingAccountBrokerSymbolFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
    ],
  },
  {
    name: DividendPaymentFilterKey.exDividendDate,
    label: 'Ex-Dividend Date',
    filter: CustomDateFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOrEqualOperator,
        operator: GridFilterOperatorEnum.afterOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOrEqualOperator,
        operator: GridFilterOperatorEnum.beforeOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
    ],
  },
]

export { getDividendFields }
